import { Input, Button, Select, Option, Checkbox } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();

export default {
    name: 'dashboardMembershipPurchaseCard',
    props: ['item'],
    components: {
        [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Button.name]: Button, [Checkbox.name]: Checkbox, LSwitch, Checkbox
    },
    data() {
        return {
            isProcessing: false,
            isUserMarkedCardForReissue: false,
            isRequestedReissue: false,
            loadedUserId: 0,
            errorMessage: null,
        };
    },
    methods: {
        expandItem(item) {
            this.$parent.expandItem(item);
        }
    },
    created() {

    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/membership/membership-purchase-card/membership-purchase-card.js